// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"VideoIframe_videoWrapper__B2ivY","iframe":"VideoIframe_iframe__WcXvq"};